import { actions } from "../slice.js";
import { thunkTypes } from "../thunk-types.js";
import { createAsyncThunk } from "@reduxjs/toolkit";
//#region src/redux/i18n/thunks/get-locale.ts
var getLocale = createAsyncThunk(thunkTypes.GET_LOCALE, async (_, { extra, dispatch }) => {
	const locale = extra.locale;
	dispatch(actions.updateLocale({ locale }));
	return locale;
});
//#endregion
export { getLocale };

//# sourceMappingURL=get-locale.js.map